import {useEffect, useState} from 'react';

export const useIsInViewPort = (ref, options = {}) => {
	const [isIntersecting, setIsIntersecting] = useState(false);

	useEffect(() => {
		const element = ref?.current;
		if (!element) {
			return;
		}

		const observer = new IntersectionObserver(
		  ([entry]) => {
			  setIsIntersecting(entry.isIntersecting);
		  },
		  options
		);

		observer.observe(element);

		return () => {
			observer.disconnect();
		};
	}, [
		ref,
		options.root,
		options.rootMargin,
		options.threshold,
	]);

	return isIntersecting;
};